import {_nativeLovWindow} from "../_nodist/_nativeElements";

//usage third party components
// react native elements https://reactnativeelements.com/docs/pricing/

//import { Text } from 'react-native-elements';

//<Text h1>Heading 1</Text>
//<Text h2>Heading 2</Text>
//<Text h3>Heading 3</Text>
//<Text h4>Heading 4</Text>

export default _nativeLovWindow
